import React from "react";

class Mentioned extends React.Component {
  constructor(props) {
    super(props);
  }

  getMentionItemRenderData = (mention) => {
    switch (mention.type) {
      case "User":
        return {
          color: "#e1efff",
          linkUrl: `/profiles/${mention.slug ?? mention.id}`,
        };
      case "Product":
        return {
          color: "#ffe6eb",
          linkUrl: `/sharehub/subscriptions/${mention.slug ?? mention.id}`,
        };
      case "Group":
        return {
          color: "#ffffc1",
          linkUrl: `/groups/${mention.slug ?? mention.id}/False`,
        };
    }
  };

  render() {
    const { color, linkUrl } = this.getMentionItemRenderData(this.props.mention);

      return (
        <a
          href={linkUrl}
          target={"_blank"}
          className={this.props.className}
          style={{ background: color }}
        >
          {this.props.children}
        </a>
      );
  }
}

export default Mentioned;
